<div class="logo">
  @if (logoURLx1) {
    <img
      srcset="{{logoURLx1|cdn}}, {{logoURLx2|cdn}} 2x"
      [alt]="text"
      class="logo__img"
      id="logo__img" />
  }
  @if (!logoURLx1) {
    <span class="logo__text-container" [style.background]="bgColor">
      <span class="logo__text" id="logo__text" [ngClass]="{'logo__text--small': size === 'small'}"
      [style.color]="fgColor">{{ shortName(text) }}</span>
    </span>
  }
</div>
